import styles from "./index.css";
import {
  LOW_IN_STOCK,
  OUT_OF_STOCK,
  COLOUR_OUT_OF_STOCK,
  SIZE_OUT_OF_STOCK,
  COLOUR_OR_SIZE_OUT_OF_STOCK,
  RESTOCKING_SOON
} from "./stockConstants";

const stockStatusMap = {
  [OUT_OF_STOCK]: styles.outOfStock,
  [COLOUR_OUT_OF_STOCK]: styles.outOfStock,
  [SIZE_OUT_OF_STOCK]: styles.outOfStock,
  [COLOUR_OR_SIZE_OUT_OF_STOCK]: styles.outOfStock,
  [LOW_IN_STOCK]: styles.lowInStock,
  [RESTOCKING_SOON]: styles.restockingSoon
};

export default stockStatus => stockStatusMap[stockStatus];
